var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex flex-col justify-start items-center",on:{"mousewheel":function($event){return _vm.wheelHandler($event)}}},[_c('canvas',{staticClass:"bg-gray-500",attrs:{"id":"imgCanvas"}},[_vm._v("canvas")])])}
var staticRenderFns = []

export { render, staticRenderFns }